import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import styled from 'styled-components';
import { getApiDataRequest, getResultData, performApiRequest } from '../redux/apiData';
import { clearModalState, updateModalOpenState } from '../redux/modal';
import { updateRedirectState } from '../redux/redirect';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import PriceTag from './shared/designElements/PriceTag';
import ImageLoader from './shared/ui/ImageLoader';
import BBCode from './shared/richText/BBCode';
import { toBreakpoint } from '../styles/breakpoints';
import { colorPalette, shadows, textStyles } from '../styles/styleGuide';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    loggedIn: Boolean(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }).user),
    postWishListRequest: getApiDataRequest(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    }),
    resultWishList: getResultData(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var router = ownProps.router,
    match = ownProps.match;
  var projectSlug = match.params.projectSlug;
  return {
    handleClick: function handleClick(houseId, wishList, loggedIn) {
      if (!loggedIn) {
        dispatch(updateRedirectState(String(projectSlug), 'closed', houseId));
        router === null || router === void 0 || router.push("/".concat(String(projectSlug), "/closed"));
        dispatch(clearModalState());
      } else {
        dispatch(performApiRequest('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: houseId
        }));
      }
    },
    closeModal: function closeModal() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var Handshake = /*#__PURE__*/function (_Component) {
  function Handshake() {
    var _this;
    _classCallCheck(this, Handshake);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Handshake, [].concat(args));
    _defineProperty(_this, "onClick", function (houseId) {
      var _this$props = _this.props,
        handleClick = _this$props.handleClick,
        wishList = _this$props.wishList,
        loggedIn = _this$props.loggedIn;
      handleClick(houseId, wishList, loggedIn || false);
    });
    return _this;
  }
  _inherits(Handshake, _Component);
  return _createClass(Handshake, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
        match = _this$props2.match,
        resultWishList = _this$props2.resultWishList,
        loggedIn = _this$props2.loggedIn,
        router = _this$props2.router,
        closeModal = _this$props2.closeModal;
      if (!loggedIn) {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed"));
      } else if (resultWishList) {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id));
        closeModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        houseVariant = _this$props3.houseVariant,
        pricelistId = _this$props3.pricelistId,
        onBoarding = _this$props3.onBoarding;
      var selectedHouse = (houseVariant.houses || []).find(function (house) {
        return house.id === pricelistId;
      });
      var houseDetails = [{
        label: 'Woonoppervlak',
        content: houseVariant.livingSpace ? "".concat(houseVariant.livingSpace, " m\xB2") : '-'
      }, {
        label: 'Slaapkamers',
        content: houseVariant.bedrooms
      }, {
        label: 'Kaveloppervlak',
        content: selectedHouse && selectedHouse.surface ? "".concat(selectedHouse.surface, " m\xB2") : '-'
      }];
      return selectedHouse ? __jsx(HandshakeContainer, {
        "data-id": "components_Handshake_HandshakeContainer"
      }, __jsx(HandshakeBlock, {
        "data-id": "components_Handshake_HandshakeBlock"
      }, __jsx(HandshakeLogo, {
        "data-id": "components_Handshake_HandshakeLogo"
      }, __jsx(ImageLoader, {
        mode: "img",
        src: onBoarding.logo,
        "data-id": "components_Handshake_ImageLoader"
      })), __jsx(HandshakeTitle, {
        "data-id": "components_Handshake_HandshakeTitle"
      }, onBoarding.title), __jsx(HandshakeText, {
        "data-id": "components_Handshake_HandshakeText"
      }, __jsx(BBCode, {
        content: onBoarding.description,
        "data-id": "components_Handshake_BBCode"
      })), __jsx(ButtonPrimary, {
        label: onBoarding.label,
        type: "button",
        clickHandler: function clickHandler() {
          return _this2.onClick(selectedHouse.id);
        },
        "data-id": "components_Handshake_ButtonPrimary"
      }), __jsx(DetailsBlock, {
        "data-id": "components_Handshake_DetailsBlock"
      }, __jsx(DetailsText, {
        "data-id": "components_Handshake_DetailsText"
      }, "Ontwerp voor:", __jsx(DetailsTitle, {
        "data-id": "components_Handshake_DetailsTitle"
      }, houseVariant.variantName, " ", selectedHouse.variantCode, __jsx("span", {
        "data-id": "components_Handshake_span"
      }, "Bouwnummer ", selectedHouse.bnr)), __jsx(Price, {
        "data-id": "components_Handshake_Price"
      }, __jsx(PriceTag, {
        price: selectedHouse.price,
        isSold: selectedHouse.status === 'sold',
        "data-id": "components_Handshake_PriceTag"
      }), __jsx(PriceText, {
        isSold: selectedHouse.status === 'sold',
        "data-id": "components_Handshake_PriceText"
      }, "v.o.n.")), __jsx(Details, {
        "data-id": "components_Handshake_Details"
      }, houseDetails.map(function (item, index) {
        return __jsx(DetailsItem, {
          key: index,
          "data-id": "components_Handshake_DetailsItem"
        }, __jsx("span", {
          "data-id": "components_Handshake_span"
        }, item.label, ":"), " ", item.content);
      }))), __jsx(DetailsImage, {
        "data-id": "components_Handshake_DetailsImage"
      }, __jsx(ImageLoader, {
        mode: "img",
        src: houseVariant.image.src,
        "data-id": "components_Handshake_ImageLoader"
      }))))) : null;
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(Handshake));
var HandshakeLogo = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 120rem;\n  align-self: flex-end;\n"])));
var PriceText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: 10rem;\n  display: ", ";\n"])), function (props) {
  return props.isSold ? 'none' : 'block';
});
var Price = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 12rem;\n  display: flex;\n  align-items: center;\n"])));
var Details = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  font-size: 14rem;\n  margin-top: 16rem;\n\n  > div {\n    margin-top: 3rem;\n  }\n"])));
var DetailsItem = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 4rem;\n"])));
var DetailsTitle = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  margin-top: 5rem;\n  color: ", ";\n  font-size: 18rem;\n"])), colorPalette.textGrey);
var DetailsImage = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 380rem;\n  height: 228rem;\n\n  ", " ", ";\n"])), toBreakpoint.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    order: 1;\n  "]))), toBreakpoint.md(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    width: 260rem;\n    height: 160rem;\n  "]))));
var DetailsText = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n\n  ", ";\n"])), textStyles.standardText, colorPalette.textGrey, toBreakpoint.md(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    order: 2;\n  "]))));
var DetailsBlock = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border-top: 1rem dashed ", ";\n  border-bottom: 1rem dashed ", ";\n  margin-top: 60rem;\n  display: flex;\n  justify-content: space-between;\n  padding: 20rem 0;\n\n  ", ";\n"])), colorPalette.lightBeige, colorPalette.lightBeige, toBreakpoint.md(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    margin-top: 40rem;\n  "]))));
var HandshakeText = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n  max-width: 700rem;\n\n  ", ";\n"])), textStyles.bodyText, colorPalette.textGrey, toBreakpoint.md(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))));
var HandshakeContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral([""])));
var HandshakeBlock = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", ";\n  align-self: center;\n  padding: 30rem 160rem 80rem 160rem;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n\n  ", " ", ";\n"])), shadows.boxPrimary, toBreakpoint.lg(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    padding: 20rem 70rem 40rem 70rem;\n  "]))), toBreakpoint.md(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    padding: 16rem 10rem 40rem 10rem;\n  "]))));
var HandshakeTitle = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n  width: 95%;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);